// Side-effect: register lib identity token + error codes once at module load.
import './error-codes'
// Side-effect: pull the input-validation schema graph so the SCHEMA_NOT_IMPORTED
// lint passes for every file under src/__schemas__/.
import './validate-input'

// Conformance Phase 3 — public selfCheck. Auto-registers on import.
import { registerLazy as registerConformance } from '@norkron/web-conformance/register-lazy'
import { selfCheck as offlineStoreSelfCheck } from './self-check'
import { LIB_VERSION as _LIB_VERSION } from './version'
import { SelfCheckOptionsSchema } from './__schemas__/SelfCheckOptions.schema'
import { selfCheckInputSchema } from './__schemas__/selfCheck.schema'
import {
	SelfCheckFindingSchema,
	ConformanceSeveritySchema,
	ConformanceCategorySchema,
} from './__schemas__/SelfCheckFinding.schema'
import { LIB_VERSIONSchema } from './__schemas__/LIB_VERSION.schema'
void [
	_LIB_VERSION,
	SelfCheckOptionsSchema,
	selfCheckInputSchema,
	SelfCheckFindingSchema,
	ConformanceSeveritySchema,
	ConformanceCategorySchema,
	LIB_VERSIONSchema,
]
registerConformance(
	'@norkron/web-offline-store',
	() => offlineStoreSelfCheck as unknown as ReturnType<Parameters<typeof registerConformance>[1]>,
)

// ── Core API ────────────────────────────────────────────────────────────────
export { defineSchema, table } from './schema'
export { createStore, Store } from './store'
export { deleteDatabase } from './migrations'

// ── React hooks (optional peer — importing core never pulls React) ───────────
export { useStore, useQuery, useMutation } from './hooks'
export type { UseQueryResult, UseMutationResult } from './hooks'

// ── Invalidation bus (advanced — manual cross-tab/worker integration) ────────
export { subscribe, invalidate } from './invalidation'

// ── Types ───────────────────────────────────────────────────────────────────
export {
	OfflineStoreError,
	type RowMeta,
	type StoredRow,
	type RowKey,
	type IndexDefinition,
	type TableDefinition,
	type TableBuilder,
	type AnyIndexDefinition,
	type AnyTableDefinition,
	type AnyTableBuilder,
	type TableInput,
	type Schema,
	type DefinedSchema,
	type InferRow,
	type Migration,
	type MigrationContext,
	type EncryptionConfig,
	type CreateStoreOptions,
	type QuotaEstimate,
	type DatabaseExport,
	type OfflineStoreErrorCode,
	type IndexQuery,
	type CursorVisitor,
} from './types'

// ── Runtime validation schemas (Wave 10 — zod mandate) ───────────────────────
export {
	CreateStoreOptionsSchema,
	SchemaSchema,
	TableDefinitionSchema,
	IndexDefinitionSchema,
	EncryptionConfigSchema,
	IndexQuerySchema,
	DatabaseExportSchema,
} from './__schemas__/WebOfflineStore.schema'

// ── Conformance ──────────────────────────────────────────────────────────────
export { selfCheck } from './self-check'
export type { SelfCheckFinding, SelfCheckOptions } from './self-check'
export { LIB_VERSION } from './version'
